import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LoadingCircleIcon3: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="loading circle icon">
      {/* <title>loading circle icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.94952 17.4876C6.27737 17.6843 6.38368 18.1095 6.18695 18.4374L6.18157 18.4464C5.98484 18.7742 5.55958 18.8806 5.23172 18.6838C4.90386 18.4871 4.79755 18.0618 4.99428 17.7339L4.99967 17.725C5.1964 17.3971 5.62166 17.2909 5.94952 17.4876Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.65361 13.9873C3.98147 14.184 4.08778 14.6093 3.89105 14.9372L3.88566 14.9461C3.68894 15.274 3.26368 15.3803 2.93582 15.1836C2.60796 14.9868 2.50165 14.5616 2.69838 14.2338L2.70376 14.2247C2.90049 13.8969 3.32575 13.7906 3.65361 13.9873Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.42997 9.76856C3.75782 9.96528 3.86414 10.3906 3.66743 10.7184L3.66204 10.7274C3.46532 11.0553 3.04007 11.1616 2.7122 10.9649C2.38434 10.7681 2.27802 10.3428 2.47474 10.015L2.48013 10.006C2.67685 9.67816 3.1021 9.57185 3.42997 9.76856Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31765 5.94189C5.64552 6.13861 5.75184 6.56386 5.55513 6.89173L5.54974 6.90071C5.35303 7.22858 4.92777 7.3349 4.5999 7.13819C4.27204 6.94148 4.16572 6.51622 4.36243 6.18836L4.36782 6.17937C4.56453 5.85151 4.98978 5.74519 5.31765 5.94189Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84108 3.5404C9.16895 3.73711 9.27525 4.16236 9.07857 4.49023L9.07318 4.49921C8.87647 4.82708 8.45122 4.93341 8.12335 4.7367C7.79548 4.54 7.68915 4.11474 7.88586 3.78688L7.89125 3.77789C8.08796 3.45002 8.51321 3.3437 8.84108 3.5404Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5608 3.69136C10.5613 3.30901 10.8717 2.99947 11.2541 3C16.225 3.00681 20.2483 7.04179 20.2414 12.0126C20.2346 16.9836 16.1996 21.0068 11.2288 21C10.095 20.9981 9.00852 20.7871 8.00788 20.4013C7.65113 20.2638 7.47344 19.863 7.61099 19.5063C7.74856 19.1495 8.14927 18.9718 8.50602 19.1094C9.35004 19.4348 10.2683 19.6137 11.2307 19.6154C15.437 19.6211 18.8511 16.2169 18.8568 12.0107C18.8625 7.80447 15.4583 4.39038 11.2521 4.38462C10.8698 4.38409 10.5603 4.07371 10.5608 3.69136Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default LoadingCircleIcon3;
